import mainTheme from './main';
import { colors } from '@material-ui/core';
const white = '#FFFFFF';
const black = '#000000';

export default {
  ...mainTheme,
  primary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[500],
    light: colors.blue[100]
  },
};